import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type Props = {
  name: React.ReactNode;
  mergedInto?: string | null;
  className?: string;
};

/**
 * An artist name, struck through and badged when the artist was merged away.
 *
 * Shared by the list and the preview on purpose: two copies of this rule would
 * drift, and a curator who sees a live-looking name in one place and a merged one
 * in the other cannot tell which is true.
 */
export const MergedName = ({ name, mergedInto, className }: Props) =>
  mergedInto ? (
    <span className={cn("inline-flex items-center gap-2 min-w-0", className)}>
      <span className="line-through opacity-60 truncate">{name}</span>
      <Badge variant="secondary" title={`Merged into ${mergedInto}`}>
        Merged
      </Badge>
    </span>
  ) : (
    <span className={className}>{name}</span>
  );
